import { FormFormat, TemplateCategory } from '@heidi/schema/ml-scribe';
import { isXmlFormTemplate } from './isXmlFormTemplate';

type FormTemplateShape =
  | {
      template_category?: string | null;
      form_format?: string | null;
    }
  | null
  | undefined;

/**
 * Is this template an XFA (LiveCycle) PDF form? Its fields address the
 * datasets record in `xml_source`, and the original PDF stays in S3 for the
 * filled download.
 *
 * Not flag-gated, for the same reason as {@link isXmlFormTemplate}: an
 * existing template must be recognised whatever the flag says.
 */
export const isXfaPdfFormTemplate = (template: FormTemplateShape): boolean =>
  template?.template_category === TemplateCategory.FORM_TEMPLATE &&
  template.form_format === FormFormat.xfa_pdf;

/**
 * Is this template filled through its `xml_source` — an XML form or an XFA
 * PDF form? Use it where the code means "XML-style editing and filling";
 * use the narrower predicates where the source file type matters.
 */
export const isXmlBackedFormTemplate = (template: FormTemplateShape): boolean =>
  isXmlFormTemplate(template) || isXfaPdfFormTemplate(template);
